import { Box, Collapse, Loader } from '@wix/design-system';
import { Edit } from '@wix/wix-ui-icons-common';
import React, { useEffect } from 'react';
import { dataHooks } from '../../utils/datahooks';
import { usePreviousState } from '../../utils/use-previous-state';
import { HoverStyledBox, ruleElementWidth } from '../hover-styled-box/hover-styled-box';
import { PrefixStatusIcon } from './prefix-status-icon';
export const RuleElement = _ref => {
  let {
    headerComponent,
    contentComponent,
    status,
    isOpen,
    onClick,
    onStatusChange,
    dataHook,
    iconButtonToolTip,
    prefixStatusIconTooltip,
    iconButtonAriaLabel,
    width = 'normal',
    disabled = false,
    isLoading = false,
    onShowPrefixIconTooltip,
    autoFocus = false,
    showIconButton = true
  } = _ref;
  const prevStatus = usePreviousState(status);
  useEffect(() => {
    if (prevStatus !== undefined && prevStatus !== status) {
      onStatusChange == null || onStatusChange();
    }
  }, [onStatusChange, prevStatus, status]);
  const isShowIconButton = showIconButton && !isOpen;
  return /*#__PURE__*/React.createElement(HoverStyledBox, {
    autoFocus: autoFocus,
    dataHook: dataHooks.ruleElementHoverBox(dataHook),
    disabled: disabled,
    iconButton: isShowIconButton ? /*#__PURE__*/React.createElement(Edit, {
      "aria-label": iconButtonAriaLabel
    }) : undefined,
    iconButtonTooltip: iconButtonToolTip,
    iconButtonZIndex: 3,
    isOpen: isOpen,
    isShowIconButton: isShowIconButton,
    notHoveredBorderColor: "#ECEFF3",
    width: width,
    onClick: !isOpen ? onClick : undefined,
    onClickIcon: isOpen ? undefined : onClick
  }, /*#__PURE__*/React.createElement(Box, {
    border: "1px solid",
    borderColor: isOpen ? '#7CAFFF' : 'inherit',
    borderRadius: "6px",
    dataHook: dataHooks.ruleElementBorderBox(dataHook),
    direction: "vertical",
    padding: isOpen ? 'SP1 SP2 SP2 SP2' : '5px SP2',
    verticalAlign: "top",
    width: ruleElementWidth[width]
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      cursor: isOpen ? 'pointer' : 'default'
    },
    onClick: isOpen ? onClick : undefined
  }, /*#__PURE__*/React.createElement(Box, {
    flexShrink: 0,
    marginRight: "SP2",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Box, {
    margin: "7px SP1 7px 0",
    verticalAlign: "middle"
  }, isLoading ? /*#__PURE__*/React.createElement(Loader, {
    size: "tiny"
  }) : status ? /*#__PURE__*/React.createElement(PrefixStatusIcon, {
    dataHook: dataHook,
    prefixStatusIconTooltip: prefixStatusIconTooltip,
    status: status,
    onShowTooltip: onShowPrefixIconTooltip
  }) : null), headerComponent)), /*#__PURE__*/React.createElement(Collapse, {
    dataHook: dataHooks.ruleElementCollapse(dataHook),
    open: isOpen
  }, contentComponent)));
};
//# sourceMappingURL=rule-element.js.map